import { useState } from 'react';

export default () => {
  // 批量裁货公共数据流 后续新增交互数据写在这里
  //   const [counter, setCounter] = useState(0);
  //   const increment = useCallback(() => setCounter((c) => c + 1), []);
  //   const decrement = useCallback(() => setCounter((c) => c - 1), []);
  //   订单类型
  const [waitNumType, setWaitNumType] = useState<number>(0);

  const waitNumTypeNameMap = new Map([
    [2, '按下单数分配'],
    [1, '按预裁数分配'],
  ]);

  const getWaitNumTypeName = () => {
    return waitNumTypeNameMap.get(waitNumType);
  };
  //   裁货二次确认-裁货勾选
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isActiveCheck, setIsActiveCheck] = useState(false);
  const [checkedIds, setCheckedIds] = useState<any[]>([]); // 分配选择的id

  return {
    waitNumType,
    setWaitNumType,
    getWaitNumTypeName,
    isAllChecked,
    setIsAllChecked,
    isActiveCheck,
    setIsActiveCheck,
    setCheckedIds,
    checkedIds,
  };
};
